import { render, staticRenderFns } from "./summary-airport.vue?vue&type=template&id=73b22ade&scoped=true"
import script from "./summary-airport.vue?vue&type=script&lang=ts&setup=true"
export * from "./summary-airport.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./summary-airport.vue?vue&type=style&index=0&id=73b22ade&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b22ade",
  null
  
)

export default component.exports